var _defs, _rect, _text, _text2, _rect2, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 800,
    viewBox: "0 0 1400 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gGreen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E7D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#0B1220",
    floodOpacity: 0.12
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .bg { fill: #F8FAFC; }\r\n      .card { fill: #FFFFFF; stroke: rgba(15,23,42,0.08); filter: url(#shadow); }\r\n      .muted { fill: #4A5568; font-family: Inter, Roboto, Arial, sans-serif; }\r\n      .title { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 800; }\r\n      .label { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 600; }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 1400,
    height: 800
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 80,
    y: 95,
    fontSize: 34
  }, "Sustainability Reporting (export/email/print)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 80,
    y: 130,
    fontSize: 16
  }, "A dashboard-style report builder: trends, category split, recommendations status, and comparisons.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "card",
    x: 80,
    y: 170,
    width: 1240,
    height: 560,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,220)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 0,
    fontSize: 18
  }, "Sustainability Reports"), /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: -22,
    width: 120,
    height: 40,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 850,
    y: 4,
    fontSize: 13
  }, "Export"), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: -22,
    width: 120,
    height: 40,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 985,
    y: 4,
    fontSize: 13
  }, "Email"), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: -22,
    width: 120,
    height: 40,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 1118,
    y: 4,
    fontSize: 13
  }, "Print"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1140,
    height: 86,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.35)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 30,
    fontSize: 12
  }, "Date range"), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 36,
    width: 300,
    height: 40,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 38,
    y: 62,
    fontSize: 14
  }, "Last 6 months v"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 350,
    y: 30,
    fontSize: 12
  }, "Report type"), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 36,
    width: 300,
    height: 40,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 366,
    y: 62,
    fontSize: 14
  }, "Comprehensive v"), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 34,
    width: 258,
    height: 44,
    rx: 14,
    fill: "url(#gBlue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 62,
    fontSize: 14,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 800
  }, "Generate report"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130,370)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 560,
    height: 210,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "rgba(33,150,243,0.18)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 36,
    fontSize: 14
  }, "Carbon footprint trend"), /*#__PURE__*/React.createElement("path", {
    d: "M40 170 C120 120, 180 150, 250 100 C320 55, 410 100, 520 70",
    fill: "none",
    stroke: "#2196F3",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 170 L40 175 L520 175",
    stroke: "rgba(148,163,184,0.6)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 0,
    width: 560,
    height: 210,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "rgba(76,175,80,0.18)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 602,
    y: 36,
    fontSize: 14
  }, "Emissions by category"), /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 120,
    r: 70,
    fill: "rgba(33,150,243,0.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 120 L860 50 A70 70 0 0 1 922 155 Z",
    fill: "rgba(76,175,80,0.35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 120 L922 155 A70 70 0 0 1 820 185 Z",
    fill: "rgba(255,193,7,0.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 120 L820 185 A70 70 0 0 1 860 50 Z",
    fill: "rgba(156,39,176,0.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 230,
    width: 1140,
    height: 170,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.35)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 266,
    fontSize: 14
  }, "Recommendations status"), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 290,
    width: 1096,
    height: 46,
    rx: 14,
    fill: "rgba(76,175,80,0.06)",
    stroke: "rgba(76,175,80,0.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 44,
    y: 318,
    fontSize: 13
  }, "Install Solar Panels"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 820,
    y: 318,
    fontSize: 13
  }, "In progress"), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 304,
    width: 120,
    height: 22,
    rx: 11,
    fill: "rgba(255,193,7,0.18)",
    stroke: "rgba(255,111,0,0.25)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1003,
    y: 319,
    fontSize: 12,
    fill: "#B45309",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 800
  }, "IN PROGRESS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductReporting);
export default __webpack_public_path__ + "static/media/product-reporting.d1099f11d524652a044f1e4bd1b884be.svg";
export { ForwardRef as ReactComponent };